import { styled } from "@vitality-ds/system";
import BaseTableStatusContainerStyles from "./styles/BaseTableStatusContainer.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseTableStatusContainer = styled("div", BaseTableStatusContainerStyles);